import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Form from "react-bootstrap/Form";
import i18n from "../../i18n";
import { useCurrency } from "../../context/CurrencyContext";
import { setUserCurrency } from "../../util/decimalFormatter";

const ChangeCurrency = () => {
  const { currency, setCurrency } = useCurrency();
  const { t } = useTranslation();

  const [state, setState] = useState({ lang: "en" });
  //   state = {
  //     lang: "en"
  //   };

  useEffect(() => {
    // const lang_code = state.lang;
    // i18n.changeLanguage(lang_code);
    // localStorage.setItem("lang", lang_code);
    // const lang = localStorage.getItem("lang");
  }, [state]);
  const currencyArr = [
    { label: "INR", code: "INR" },
    { label: "EUR", code: "EUR" },
    { label: "USD", code: "USD" },
    // { label: "Russian", code: "rus" },
    // { label: "Persian", code: "per" },
    // { label: "Arabic", code: "ar" }
  ];

  const onChangeLang = (selectedCurrency) => {
    console.log(selectedCurrency, "selectedCurrency");
    setUserCurrency(selectedCurrency); // Save to localStorage
    setCurrency(selectedCurrency); // Update state to reflect UI
    window.location.reload();
  };

  // const { t } = this.props;
  // const { lang } = this.state;
  return (
    <>
      <Form.Select
        aria-label="Default select example"
        defaultValue={i18n.language}
        onChange={(e) => onChangeLang(e.target.value)}
        name="lang"
        className="lang-control form-control"
        value={currency}
      >
        {currencyArr.map(({ code, label }) => (
          <option key={code} value={code}>
            {label}
          </option>
        ))}
      </Form.Select>
    </>
  );
};
export default ChangeCurrency;
